export default "<app-booking-list></app-booking-list>\r\n";